import { withI18nContext, useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, NavigationEvents, ProductLine } from '@mc/track-event'
import Link from 'components/Link'
import { trackNavigationClick } from 'components/Navigation/events'
import { useExperiment } from '../../hooks/useExperiment'
import {
  STANDALONE_BUNDLE_I18N_NAMESPACE,
  i18nInstance,
} from '../../i18n/i18nInstance'

const AllAccessNavLinkContent = withI18nContext(i18nInstance)(({
  className = '',
  product,
}: {
  className?: string
  product?: (typeof ProductLine)[keyof typeof ProductLine]
}) => {
  const { t } = useTranslation(STANDALONE_BUNDLE_I18N_NAMESPACE)
  const ctaCopy = t('nav.allAccess')

  return (
    <Link
      href={paths.acceleratorBundle}
      className={`mc-text-x-small mc-text--bold mc-ml-8 ${className}`}
      onClick={() =>
        trackNavigationClick(
          ctaCopy,
          NavigationEvents.LEVELS.PRIMARY,
          Locations.UTILITY_NAVIGATION,
          product,
        )
      }
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
})

export const AllAccessNavLink = ({
  className,
  product,
}: {
  className?: string
  product?: (typeof ProductLine)[keyof typeof ProductLine]
}) => {
  const { isEnabled } = useExperiment()

  if (!isEnabled) return null

  return <AllAccessNavLinkContent className={className} product={product} />
}
